/* eslint-env browser */

(function (window, document) {

  $(document).ready(function() {
    $('#subscribe-form').submit(function(e) {
      e.preventDefault();

      var $form = $(e.target);
      var $message = $('.subscribe-form-message', $form);
      var email = $form.find('input[name=email]').val().replace(/^\s+|\s+$/, '');
      var pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!pattern.test(email)) {
        $message.text('Please enter valid email address.')
      } else {
        $.ajax('/xhr/email/subscribe', { method: 'POST', data: { email: email } });
        $message.text('Thank you for subscribing!')
      }
    });
  });

})(window, document);
